(function () {
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  const STORAGE_KEY = 'polar_last_touch';
  const SYNC_DEBOUNCE_MS = 500;
  const MAX_SYNC_ATTEMPTS = 3;

  // In-memory fallback for when sessionStorage is unavailable (Safari private mode, quota, policy)
  let _memoryFallback = null;
  let syncTimer = null;
  let _syncAttempts = 0;

  function sanitizeUtmValue(val) {
    return String(val).replace(/[^a-zA-Z0-9\-_./ ]/g, '').slice(0, 200);
  }

  function parseUtmsFromSearch(search) {
    const params = new URLSearchParams(search);
    const utms = {};
    let found = false;
    UTM_KEYS.forEach(function (key) {
      const val = params.get(key);
      if (val) {
        utms[key] = sanitizeUtmValue(val);
        found = true;
      }
    });
    // Capture referrer once at init alongside UTMs, before any navigation changes it
    if (document.referrer) utms._referrer = sanitizeUtmValue(document.referrer);
    return found ? utms : null;
  }

  function storeUtms(utms) {
    _memoryFallback = utms;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utms));
    } catch (e) {
      // sessionStorage unavailable — in-memory fallback active
    }
  }

  function loadUtms() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : _memoryFallback;
    } catch (e) {
      return _memoryFallback;
    }
  }

  function buildCartAttributes(utms) {
    const attrs = {};
    UTM_KEYS.forEach(function (key) {
      if (utms[key]) attrs[key] = utms[key];
    });
    if (utms._referrer) attrs['referrer'] = utms._referrer;
    return attrs;
  }

  function doSync() {
    const utms = loadUtms();
    if (!utms) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ attributes: buildCartAttributes(utms) }),
    })
      .then(function (response) {
        if (response.ok) {
          _syncAttempts = 0;
        } else if (_syncAttempts < MAX_SYNC_ATTEMPTS) {
          _syncAttempts++;
          setTimeout(doSync, 1000 * _syncAttempts);
        }
      })
      .catch(function () {
        if (_syncAttempts < MAX_SYNC_ATTEMPTS) {
          _syncAttempts++;
          setTimeout(doSync, 1000 * _syncAttempts);
        }
      });
  }

  function syncAttributesToCart() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(doSync, SYNC_DEBOUNCE_MS);
  }

  // Capture UTMs from current URL (last-touch: overwrites any previously stored value)
  const currentUtms = parseUtmsFromSearch(window.location.search);
  if (currentUtms) storeUtms(currentUtms);

  // Sync to cart on load
  syncAttributesToCart();

  // rebuy:cart.change fires on every Rebuy cart mutation — re-sync to prevent Rebuy from wiping attributes.
  // rebuy:smartcart.ready fires on Smart Cart initialization — guards against attribute loss on Rebuy init.
  // addEventListener is safe to register unconditionally — no-op if Rebuy is absent.
  document.addEventListener('rebuy:cart.change', syncAttributesToCart);
  document.addEventListener('rebuy:smartcart.ready', syncAttributesToCart);

  // Re-sync on native cart updates from the theme pubsub
  document.addEventListener('cart:updated', syncAttributesToCart);
})();
